import React from 'react'
import { DataChartCard } from '@diversioteam/diversio-ds'

import { useSurveyInformation } from 'hooks/useSurveyInformation/useSurveyInformation'

export const SurveyParticipation = () => {
    const { isLoading, data } = useSurveyInformation()

    if (isLoading || !data) {
        return null
    }

    const chartCardData = data.pastSurveys
        .map((survey) => ({
            year: survey.year,
            quarter: survey.quarter,
            value: survey.participationRate,
        }))
        .filter((survey) => survey.value > 0)

    if (!chartCardData.length) {
        return null
    }

    return (
        <div className="ddsi-card survey-participation-card">
            <DataChartCard data={chartCardData} data-joyride="survey-participation-card" />
        </div>
    )
}
